<div class ="travel-article__section-spacer" *ngIf="!isLoading && travelArticles && travelArticles.length > 0"></div>

<div class="detail-page__rail-content" *ngIf="!isLoading && travelArticles && travelArticles.length > 0">
  <div class="section__right-rail">
    <div class="section__header">
      <h2 class="section__header-text">Travel Articles</h2>
    </div>
    <div class="section__body">

      <div class="spinnerContainer" *ngIf="isLoading; else articleMain">
        <mat-spinner  class="spinner" [diameter]="100" [color]="'primary'"></mat-spinner>
      </div>
    </div>
  </div>
</div>

<ng-template #articleMain>
  <ul class="travel-article__listing" *ngIf="travelArticles && travelArticles.length > 0; else articlePlaceholder">
    <li class="travel-article__article" *ngFor="let article of this.travelArticles">
      <div class="travel-article__header">
        <a target="_blank" [href]="article.Url"><div class="travel-article__title" *ngIf="article.Title" [innerHtml]="article.Title"></div></a>
        <div class="travel-article__first-line">
          <div class="travel-article__author" *ngIf="article.AuthorOverview && article.AuthorOverview.name">{{ article.AuthorOverview.name }}</div>
          <div class="travel-article__date" *ngIf="article.Date">{{ article.Date | date: 'shortDate' }}</div>
        </div>
      </div>
      <!-- <div *ngIf="review.review" class="reviews__review-body" [class.show]="review.displayFull">{{ review.review }}</div> -->
      <app-truncated-text *ngIf="article.Intro" class="travel-article__body" [text]="article.Intro" [limit]="250"></app-truncated-text>
      <div class="travel-article__photo-gallery-spacer" *ngIf="article.Image"></div>
      <img *ngIf="article.Image" [src]="article.Image" width="340" height="191" />
      <!--- <ngx-gallery *ngIf="review.galleryPhotos && review.galleryPhotos.length" [options]="galleryOptions" [images]="review.galleryPhotos"></ngx-gallery> -->
    </li>
  </ul>
</ng-template>
<ng-template #articlePlaceholder>
  <div class="detail-page__placeholder reviews__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">Be the first to review.</div>
  </div>
</ng-template>
